import { Link } from 'react-router-dom';
import {
  Container,
  Title,
  Text,
  Button,
  Group,
  Stack,
  Center,
  Box
} from '@mantine/core';
import {
  IconArrowLeft,
  IconCrown,
  IconBuildingStore,
  IconCategory
} from '@tabler/icons-react';
import PrincessCarousel from '../components/PrincessCarousel';

const PiggySubscriptionPage = () => {
  return (
    <Container size="md" py="xl" style={{ overflow: 'hidden' }}>
      <Stack gap="xl">
        <Group justify="space-between" align="center">
          <Button
            component={Link}
            to="/"
            variant="subtle"
            leftSection={<IconArrowLeft size="1rem" />}
          >
            Back to Home
          </Button>
        </Group>

        <Center>
          <Stack gap="lg" align="center" maw={600}>
            <IconCrown size={64} color="var(--mantine-color-grape-6)" />

            <Title order={1} ta="center" size="2.2rem" c="grape">
              Choose your princess, choose the color, get your pics!
            </Title>

            <Text size="lg" ta="center" c="dimmed" maw={500}>
              Spoil your princess with a pedicure to unlock access to private messages and requests
            </Text>

            <Group mt="md" justify="center">
              <Button
                component={Link}
                to="/princesses"
                size="lg"
                color="pink"
                leftSection={<IconBuildingStore size="1.2rem" />}
              >
                Browse Princesses
              </Button>
              <Button
                component={Link}
                to="/browse-categories"
                size="lg"
                variant="outline"
                color="grape"
                leftSection={<IconCategory size="1.2rem" />}
              >
                Browse Categories
              </Button>
            </Group>
          </Stack>
        </Center>

        {/* Rotating Princess Carousel */}
        <PrincessCarousel />
      </Stack>
    </Container>
  );
};

export default PiggySubscriptionPage;
